import React, { ChangeEvent, Component, ReactNode } from 'react';
import CustomLoading from '../../../custom/CustomLoading';
import ValueFactory from '../../../../util/ValueFactory';
import { Syntax } from '@trlogic/ui-pack';
import { FilterSegmentItem } from 'domain/chart/editor/Segment';
import MessageUtil from '../../../../util/MessageUtil';
import { SegmentItem } from '../../../../domain/chart/ChartDomains';
import FormicaFilterItemComponent from '../../FormicaFilterItemComponent';

class SegmentFilter extends Component<Props> {
  render() {
    const { segmentItem } = this.props;
    const filterSegment = segmentItem ? segmentItem.segments.filter : null;
    if (filterSegment == null) return <CustomLoading />;
    return (
      <div className={'flex flex-col w-full h-full gap-y-4'}>
        <label htmlFor={'filters'} className={'text-sm text-f-black-2'}>
          {' '}
          Filters{' '}
        </label>
        <div id={'filters'} className={'flex flex-col gap-y-5 w-full h-full'}>
          {this.getFilterItems()}
        </div>
        <a onClick={() => this.addFilter()} className={'px-2 py-2 bg-white border-[1px] border-f-purple text-f-purple w-full rounded cursor-pointer'}>
          {' '}
          + Add Filter
        </a>
      </div>
    );
  }

  private removeFilter = (filter: FilterSegmentItem) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const filterSegment = segmentItem ? segmentItem.segments.filter : null;
    if (segmentItem == null || filterSegment == null) return;
    filterSegment.items = filterSegment.items.filter((f: FilterSegmentItem) => f.label != filter.label);
    onChangeSegmentItem(segmentItem);
  };

  private addFilter() {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const filterSegment = segmentItem ? segmentItem.segments.filter : null;
    if (segmentItem == null || filterSegment == null) return;
    filterSegment.items = [
      ...filterSegment.items,
      {
        label: 'New Filter' + (filterSegment.items.length + 1),
        syntax: ValueFactory.initializeExpression(),
      } as FilterSegmentItem,
    ];
    onChangeSegmentItem(segmentItem);
  }

  private onFilterNameChange = (e: ChangeEvent<HTMLInputElement>, filter: FilterSegmentItem) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const filterSegment = segmentItem ? segmentItem.segments.filter : null;
    let isExistFilterName = false;
    if (segmentItem == null || filterSegment == null) return;
    filterSegment.items.forEach((item: FilterSegmentItem) => {
      if (item.label == e.currentTarget.value) {
        isExistFilterName = true;
      }
    });
    if (isExistFilterName) {
      MessageUtil.alreadyExist('Filter name already exist');
    } else {
      filter.label = e.currentTarget.value;
      onChangeSegmentItem(segmentItem);
    }
  };

  private getFilterItems = (): ReactNode => {
    const { segmentItem } = this.props;
    const filterSegment = segmentItem ? segmentItem.segments.filter : null;
    if (segmentItem == null || filterSegment == null) return;
    return filterSegment.items.map((filter: FilterSegmentItem, index: number) => {
      return (
        <div key={index} className={'flex flex-col w-full items-center group '}>
          <FormicaFilterItemComponent
            filter={filter}
            onChangeFilterName={this.onFilterNameChange}
            onChangeSyntax={this.onChangeFilterItemSyntax}
            removeFilter={this.removeFilter}
            variables={{}}
          />
        </div>
      );
    });
  };

  private onChangeFilterItemSyntax = (filter: FilterSegmentItem, syntax: Syntax) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const filterSegment = segmentItem ? segmentItem.segments.filter : null;
    if (segmentItem == null || filterSegment == null) return;
    filter.syntax = syntax;
    onChangeSegmentItem(segmentItem);
  };
}

interface Props {
  segmentItem: SegmentItem | null;
  onChangeSegmentItem: (segmentItem: SegmentItem) => void;
}

export default SegmentFilter;
